import { Box, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const ScanSessionDetailsRow = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

export const ScanSessionDetailedDetails = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const ScanSessionResultsRow = styled('li')(({ theme }) => ({
    listStyleType: 'none',
    paddingLeft: theme.spacing(2),
}));

export const ListControlsContainer = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    flexWrap: 'wrap',
    alignItems: 'bottom',
    marginTop: theme.spacing(2),
    gap: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
    },

    [theme.breakpoints.up('md')]: {
        gap: theme.spacing(1),
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },


    [theme.breakpoints.up('chromebook')]: {
        justifyContent: 'end',
    },
}));
